export * from './baThemeRun.directive';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/directives/baThemeRun/index.ts